// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx Actions
import { setCustomPDFReportBuilderStore } from '../custom-pdf-report-builder/custom-pdf-report-builder.action';
import { setDataSource } from './data-source.action';
export const data_source = createReducer('legacy', on(setCustomPDFReportBuilderStore, setDataSource, (state, action) => {
    return action.data_source ?? 'legacy';
}));
